
import React from 'react';
import { Divider, Skeleton } from '../../../../../components/UiComponents/Ui';

const RedirectTabSkeleton = () => {
  return (
    <div className="space-y-2 min-h-screen px-6">
      <div className="space-y-3">
        <div className="space-y-[18px]">
          <div className="space-y-2">
            <div className="block">
              <Skeleton width="250px" height="32px" />
            </div>
            <div className="block">
              <Skeleton width="300px" height="20px" />
            </div>
          </div>
          <Divider />
        </div>

        <div className="px-[18px] flex justify-between items-center">
          <div className="space-y-1">
            <div className="block">
              <Skeleton width="150px" height="24px" />
            </div>
            <div className="block">
              <Skeleton width="200px" height="16px" />
            </div>
          </div>
          <div className="block">
            <Skeleton width="120px" height="24px" />
          </div>
        </div>

        {/* Encryption Settings Card */}
        <div className="px-6 py-3 space-y-[14px] border border-gray-200 shadow-cardShadow rounded-xl bg-[#FFFFFF]">
          <div className="space-y-1">
            <div className="block">
              <Skeleton width="180px" height="24px" />
            </div>
            <div className="block">
              <Skeleton width="300px" height="16px" />
            </div>
          </div>
          <div className="space-y-[14px]">
            <div className="block">
              <Skeleton width="100%" height="40px" />
            </div>
            <div className="block">
              <Skeleton width="100%" height="40px" />
            </div>
            <div className="block">
              <Skeleton width="100%" height="40px" />
            </div>
          </div>
        </div>

        {/* URL Configuration Card */}
        <div className="px-6 py-3 space-y-[14px] border border-gray-200 shadow-cardShadow rounded-xl bg-[#FFFFFF]">
          <div className="space-y-1 flex flex-col">
            <Skeleton width="160px" height="24px" />
            <Skeleton width="350px" height="16px" />
          </div>
          <div className="space-y-[20px] mt-10">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="space-y-[6px]">
                <Skeleton width="120px" height="20px" />
                <div className="space-y-1">
                  <Skeleton width="100%" height="40px" />
                  <div className="flex items-center gap-[3px]">
                    <Skeleton width="16px" height="16px" circle />
                    <Skeleton width="200px" height="16px" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Advanced Options Card */}
        <div className="px-6 py-4 space-y-[14px] border border-gray-200 shadow-cardShadow rounded-xl bg-[#FFFFFF]">
          <div className="flex justify-between items-center">
            <Skeleton width="150px" height="24px" />
            <Skeleton width="20px" height="20px" />
          </div>
        </div>

        {/* Bottom Buttons */}
        <section className="pt-5 sticky bottom-0">
          <div className="flex justify-end gap-2">
            <Skeleton width="100px" height="36px" />
            <Skeleton width="120px" height="36px" />
          </div>
        </section>
      </div>
    </div>
  );
};

export default RedirectTabSkeleton;
